import React from "react";
import dayjs from "dayjs";
import CountrySelector from "./countrySelector";
import { StoreButtons } from "../../components/global/buttons";
import { useMediaQuery } from "react-responsive";
import { GlobalStore } from "../../stores/global";
import { FacebookCircleIco, TwitterIco, InstagramIco, LinkedInIco } from "@speedoc/design-assets/build/icons/index";
import { slugToCountryPathname, validPath } from "../../utils/strings";
import { Link as LinkT } from "react-router-dom";
import { PhoneBlack } from "@speedoc/design-assets/build/icons/index";

const getCountryLink = countryCode =>
  countryCode.toString().toLowerCase() === "sg" ? "https://sg.speedoc.com/en" : "https://my.speedoc.com/en";

const Link = props => {
  if (!!props.to && props.to.startsWith("http")) {
    return (
      <a {...props} href={props.to} target={"_blank"} rel="noopener noreferrer">
        {props.children}
      </a>
    );
  }
  return <LinkT {...props} />;
};

function Footer() {
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });

  const { structure, currentCountry, currentCountryCode, defaultCountryName } = GlobalStore.useState(c => c);
  const content = structure?.footer;

  return (
    <div id="footer">
      <div className="lowerContentContainer">
        <div className="lowerContent">
          <div className="grid">
            <section className="acuteCareSection">
              <h3>{content?.services?.title}</h3>
              <ul>
                {content?.services?.elements?.map(
                  ({ text, pathSG, pathMY, comingSoonSG, comingSoonMY }, i) =>
                    ((currentCountryCode === "SG" && pathSG) || (currentCountryCode === "MY" && pathMY)) && (
                      <li key={i}>
                        <Link
                          link={currentCountryCode === "SG" ? pathSG : pathMY}
                          text={text}
                          comingSoon={currentCountryCode === "SG" ? comingSoonSG : comingSoonMY}
                        />
                      </li>
                    )
                )}
              </ul>
            </section>

            <section className="preventiveCareSection">
              <h3>{content?.preventiveCare?.title}</h3>
              <ul>
                {content?.preventiveCare?.elements?.map(
                  ({ text, pathSG, pathMY, comingSoonSG, comingSoonMY }, i) =>
                    ((currentCountryCode === "SG" && pathSG) || (currentCountryCode === "MY" && pathMY)) && (
                      <li key={i}>
                        <Link
                          link={currentCountryCode === "SG" ? pathSG : pathMY}
                          text={text}
                          comingSoon={currentCountryCode === "SG" ? comingSoonSG : comingSoonMY}
                        />
                      </li>
                    )
                )}
              </ul>
            </section>

            <section className="chronicConditionSection">
              <h3>{content?.chronicConditionManagement?.title}</h3>
              <ul>
                {content?.chronicConditionManagement?.elements?.map(
                  ({ text, pathSG, pathMY, comingSoonSG, comingSoonMY }, i) =>
                    ((currentCountryCode === "SG" && pathSG) || (currentCountryCode === "MY" && pathMY)) && (
                      <li key={i}>
                        <Link
                          link={currentCountryCode === "SG" ? pathSG : pathMY}
                          text={text}
                          comingSoon={currentCountryCode === "SG" ? comingSoonSG : comingSoonMY}
                        />
                      </li>
                    )
                )}
              </ul>
            </section>

            <section className="businessSection">
              <h3>{content?.businesses?.title}</h3>
              <ul>
                {content?.businesses?.elements?.map(
                  ({ text, link, pathSG, pathMY, comingSoonSG, comingSoonMY }, i) =>
                    ((currentCountryCode === "SG" && pathSG) || (currentCountryCode === "MY" && pathMY) || link) && (
                      <li key={i}>
                        <Link
                          link={(currentCountryCode === "SG" ? pathSG : pathMY) || link}
                          text={text}
                          comingSoon={currentCountryCode === "SG" ? comingSoonSG : comingSoonMY}
                        />
                      </li>
                    )
                )}
              </ul>
            </section>

            <section className="resourcesSection">
              <h3>{content?.resources?.title}</h3>
              <ul>
                {content?.resources?.elements?.map(
                  ({ text, pathSG, pathMY, comingSoonSG, comingSoonMY }, i) =>
                    ((currentCountryCode === "SG" && pathSG) || (currentCountryCode === "MY" && pathMY)) && (
                      <li key={i}>
                        <Link
                          link={currentCountryCode === "SG" ? pathSG : pathMY}
                          text={text}
                          comingSoon={currentCountryCode === "SG" ? comingSoonSG : comingSoonMY}
                        />
                      </li>
                    )
                )}
              </ul>
            </section>

            <section className="languageSection">
              <StoreButtons />
              <div>
                <CountrySelector
                  countryCode={currentCountryCode}
                  countryName={currentCountry?.name || defaultCountryName}
                />
              </div>
              {!isMobile && (
                <div className="fullAddressSection">
                  {currentCountryCode === "SG" && (
                    <>
                      <h3>{content?.addressSG?.title}</h3>
                      <ul>
                        {content?.addressSG?.entries?.map(({ text, id }) => (
                          <p className="address" key={id}>
                            {text}
                            <br />
                          </p>
                        ))}
                      </ul>
                      <p>
                        <a href={`tel:${content.phoneSG}`}>{content.phoneSG}</a>
                      </p>
                      <p>
                        <a href={`mailto:${content?.emailSG}`}>{content?.emailSG}</a>
                      </p>
                    </>
                  )}
                  {currentCountryCode === "MY" && (
                    <>
                      <h3>{content?.addressMY?.title}</h3>
                      <ul>
                        {content?.addressMY?.entries?.map(({ text }, i) => (
                          <p className="address" key={i}>
                            {text}
                            <br />
                          </p>
                        ))}
                      </ul>
                      <p>
                        <a href={`tel:${content.phoneMY}`}>{content.phoneMY}</a>
                      </p>
                      <p>
                        <a href={`mailto:${content?.emailMY}`}>{content?.emailMY}</a>
                      </p>
                    </>
                  )}
                </div>
              )}
            </section>

            {isMobile && (
              <div className="fullAddressSection">
                {currentCountryCode === "SG" && (
                  <>
                    <h3>{content?.addressSG?.title}</h3>
                    <ul>
                      {content?.addressSG?.entries?.map(({ text }, i) => (
                        <p className="address" key={i}>
                          {text}
                          <br />
                        </p>
                      ))}
                    </ul>
                    <p>
                      <a href={`tel:${content.phoneSG}`}>{content.phoneSG}</a>
                    </p>
                    <p>
                      <a href={`mailto:${content?.emailSG}`}>{content?.emailSG}</a>
                    </p>
                  </>
                )}
                {currentCountryCode === "MY" && (
                  <>
                    <h3>{content?.addressMY?.title}</h3>
                    <ul>
                      {content?.addressMY?.entries?.map(({ text }, i) => (
                        <p className="address" key={i}>
                          {text}
                          <br />
                        </p>
                      ))}
                    </ul>
                    <p>
                      <a href={`tel:${content.phoneMY}`}>{content.phoneMY}</a>
                    </p>
                    <p>
                      <a href={`mailto:${content?.emailMY}`}>{content?.emailMY}</a>
                    </p>
                  </>
                )}
              </div>
            )}

            <div className="companyInfoSection">
              <div className="copyright">
                <span>© Copyright {dayjs().format("YYYY")} Speedoc. All rights reserved.</span>
              </div>
              <div className="policy">
                {content?.policies?.elements?.map(
                  ({ text, pathSG, pathMY, comingSoonSG, comingSoonMY }, i) =>
                    ((currentCountryCode === "SG" && pathSG) || (currentCountryCode === "MY" && pathMY)) && (
                      <Link
                        key={i}
                        link={currentCountryCode === "SG" ? pathSG : pathMY}
                        text={text}
                        comingSoon={currentCountryCode === "SG" ? comingSoonSG : comingSoonMY}
                      />
                    )
                )}
              </div>
            </div>

            <div className="socialLogosSection">
              <a href={process.env.REACT_APP_FACEBOOK} rel="noopener noreferrer" target="_blank">
                <img
                  alt="facebook logo"
                  src="//public.speedoc.com/design/images/speedoc.com/social-logos/facebook.svg"
                />
              </a>
              <a href={process.env.REACT_APP_TWITTER} rel="noopener noreferrer" target="_blank">
                <img alt="twitter logo" src="//public.speedoc.com/design/images/speedoc.com/social-logos/twitter.svg" />
              </a>
              <a href={process.env.REACT_APP_INSTAGRAM} rel="noopener noreferrer" target="_blank">
                <img
                  alt="instagram logo"
                  src="//public.speedoc.com/design/images/speedoc.com/social-logos/instagram.svg"
                />
              </a>
              <a href={process.env.REACT_APP_LINKEDIN} rel="noopener noreferrer" target="_blank">
                <img
                  alt="linkedin logo"
                  src="//public.speedoc.com/design/images/speedoc.com/social-logos/linkedin.svg"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function FooterV4() {
  const isMobile = useMediaQuery({ query: "(max-width: 1100px)" });

  const { structure, currentCountry, currentCountryCode, defaultCountryName } = GlobalStore.useState(c => c);
  let content = structure?.footers?.length && structure.footers[0];

  content?.footerSection?.forEach((section, index) => {
    if (section.title === "Services") {
      content = {
        ...content,
        services: content.footerSection[index]
      };
    } else if (section.title === "Types of Care") {
      content = {
        ...content,
        typeOfCare: content.footerSection[index]
      };
    } else if (section.title === "COVID-19") {
      content = {
        ...content,
        covid19: content.footerSection[index]
      };
    } else if (section.title === "Company") {
      content = {
        ...content,
        company: content.footerSection[index]
      };
    } else if (section.title === "Partners") {
      content = {
        ...content,
        partners: content.footerSection[index]
      };
    } else if (section.title === "Help") {
      content = {
        ...content,
        help: content.footerSection[index]
      };
    }
  });

  return (
    <div id="footer" className="footerV4">
      <div className="lowerContentContainer">
        <div className="lowerContent">
          <div className="grid">
            <div className="logo">
              <a href={getCountryLink(currentCountryCode)}>
                <img alt={"logo"} src={"https://public.speedoc.com/strapi/logo-mobile.png?455486908.6"} />
              </a>
            </div>

            <section className="services">
              <h3>{content?.services?.title}</h3>
              <ul>
                {content?.services?.elements?.map(({ text, path }, i) => (
                  <li key={i}>
                    <Link to={validPath(path)}>{text}</Link>
                  </li>
                ))}
              </ul>
            </section>

            <section className="typeOfCare">
              <h3>{content?.typeOfCare?.title}</h3>
              <ul>
                {content?.typeOfCare?.elements?.map(({ text, path }, i) => (
                  <li key={i}>
                    <Link to={validPath(path)}>{text}</Link>
                  </li>
                ))}
              </ul>
            </section>

            <section className="covid19">
              <h3>{content?.covid19?.title}</h3>
              <ul>
                {content?.covid19?.elements?.map(({ text, path }, i) => (
                  <li key={i}>
                    <Link to={validPath(path)}>{text}</Link>
                  </li>
                ))}
              </ul>
            </section>

            <section className="company">
              <h3>{content?.company?.title}</h3>
              <ul>
                {content?.company?.elements?.map(({ text, path }, i) => (
                  <li key={i}>
                    <Link to={validPath(path)}>{text}</Link>
                  </li>
                ))}
              </ul>
            </section>

            <section className="partners">
              <h3>{content?.partners?.title}</h3>
              <ul>
                {content?.partners?.elements?.map(({ text, path }, i) => (
                  <li key={i}>
                    <Link to={validPath(path)}>{text}</Link>
                  </li>
                ))}
              </ul>
            </section>

            <section className="help">
              <h3>{content?.help?.title}</h3>
              <ul>
                {content?.help?.elements?.map(({ text, path }, i) => (
                  <li key={i}>
                    <Link to={validPath(path)}>{text}</Link>
                  </li>
                ))}
              </ul>
            </section>

            <section className="languageSection">
              <div>
                <CountrySelector
                  countryCode={currentCountryCode}
                  countryName={currentCountry?.name || defaultCountryName}
                />
              </div>
              {!isMobile && (
                <div className="fullAddressSection">
                  <h3>{content?.address?.title}</h3>
                  <ul>
                    {content?.address?.entries?.map(({ text, id }) => (
                      <p className="address" key={id}>
                        {text}
                        <br />
                      </p>
                    ))}
                  </ul>
                  <p>
                    <a href={`mailto:${content?.email}`}>{content?.email}</a>
                  </p>
                  <div className="viewAllLocation">
                    <Link to={slugToCountryPathname("contact-us")}> View all locations </Link>
                  </div>
                  <div>
                    <a href={`tel:${content.phoneNumber}`} className="hotline">
                      <span>{"24 Hour Hotline"}</span>
                      <div>
                        <PhoneBlack />
                        <span>{content.phoneNumber}</span>
                      </div>
                    </a>
                  </div>
                </div>
              )}
            </section>

            {isMobile && (
              <div className="fullAddressSection">
                <h3>{"Speedoc " + content?.address?.title}</h3>
                <ul>
                  {content?.address?.entries?.map(({ text }, i) => (
                    <p className="address" key={i}>
                      {text}
                      <br />
                    </p>
                  ))}
                </ul>
                <p>
                  <a href={`mailto:${content?.email}`}>{content?.email}</a>
                </p>
                <div className="viewAllLocation">
                  <Link to={slugToCountryPathname("contact-us")}> View all locations </Link>
                </div>
                <div>
                  <a href={`tel:${content.phoneNumber}`} className="hotline">
                    <span>{"24 Hour Hotline"}</span>
                    <div>
                      <PhoneBlack />
                      <span>{content.phoneNumber}</span>
                    </div>
                  </a>
                </div>
              </div>
            )}

            {isMobile && <StoreButtons />}

            <div className="companyInfoSection">
              <div className="copyright">
                {!isMobile ? (
                  <>
                    <StoreButtons />
                    <div>
                      <span>© Copyright {dayjs().format("YYYY")} Speedoc. </span>
                      <span>All rights reserved.</span>
                    </div>
                  </>
                ) : (
                  <>
                    <span>© Copyright {dayjs().format("YYYY")} Speedoc. </span>
                    <span>All rights reserved.</span>
                  </>
                )}
              </div>
              {isMobile && (
                <div className="policy">
                  {content?.policies?.elements?.map(({ text, path, comingSoonSG, comingSoonMY }, i) => (
                    <Link key={i} to={validPath(path)}>
                      {text}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <div className="socialLogosSection">
              <a href={process.env.REACT_APP_FACEBOOK} rel="noopener noreferrer" target="_blank">
                <FacebookCircleIco />
              </a>
              <a href={process.env.REACT_APP_TWITTER} rel="noopener noreferrer" target="_blank">
                <TwitterIco />
              </a>
              <a href={process.env.REACT_APP_INSTAGRAM} rel="noopener noreferrer" target="_blank">
                <InstagramIco />
              </a>
              <a href={process.env.REACT_APP_LINKEDIN} rel="noopener noreferrer" target="_blank">
                <LinkedInIco />
              </a>
            </div>

            {content.businessCertificationLogos && content.businessCertificationLogos.length > 0 && (
              <div className="businessCertification">
                {(content.businessCertificationLogos.length > 4
                  ? content.businessCertificationLogos.slice(0, 4)
                  : content.businessCertificationLogos
                ).map((logo, index) => (
                  <img alt="logo" key={index} src={logo.media.url} />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

let tmp = Footer;
if (process.env.REACT_APP_V4_ENABLE === "true") {
  tmp = FooterV4;
}
export default tmp;
